import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { allowedIntervals } from './allowedIntervals';
import { intervalTranslations } from './translations';
import { getFieldLabel } from '../../../utils/metadataProperties';
import { Breakdown } from '../Breakdown';
import { ConfigMenu } from '../ConfigMenu';
import { SelectDataPoint } from '../SelectDataPoint';
import { FieldInputContainer } from '../styled';
export function DateHistogramInput(props) {
    const { pathBase, remove, isSubAggregation = false } = props;
    const currentPath = `${pathBase}.dateHistogramInput`;
    const [field, , helpers] = useField(currentPath);
    const handleChangeInterval = (val) => {
        helpers.setValue(Object.assign(Object.assign({}, field.value), { interval: val }));
    };
    return (<Fragment>
      <FieldInputContainer>
        <SelectDataPoint label={t({
            message: 'Date period',
            comment: 'Insights widget form: Date historam field',
        })} selectedValue={getFieldLabel(field.value.field)} name={pathBase} onRemove={remove}/>

        <ConfigMenu label={t({
            message: 'Config',
            comment: 'Insights: Date histogram interval configuration',
        })} secondary={intervalTranslations(field.value.interval)}>
          {allowedIntervals().map((interval) => (<Menu.ItemRadio key={interval.value} checked={interval.value === field.value.interval} onChange={() => handleChangeInterval(interval.value)}>
              {interval.label}
            </Menu.ItemRadio>))}
        </ConfigMenu>
      </FieldInputContainer>
      {!isSubAggregation && <Breakdown pathBase={currentPath}/>}
    </Fragment>);
}
